import { motion } from "framer-motion";

export default function MailChimpSignup({ isMobile = false }) {
	const bounceTransition = {
		duration: 0.4,
		ease: [0.68, -0.25, 0.265, 1.25],
	};
	return (
		<div id="mc_embed_shell" className="flex mr-auto">
			<div id="mc_embed_signup" className="container mx-auto px-4">
				<motion.div
					className="max-w-3xl mx-auto text-center"
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true }}
					transition={bounceTransition}
				>
					<form
						action="https://offcutshades.us14.list-manage.com/subscribe/post?u=269c387d04f73bada3a71bcd5&amp;id=2d9f792d6b&amp;f_id=00fc8fe0f0"
						method="post"
						id="mc-embedded-subscribe-form"
						name="mc-embedded-subscribe-form"
						target="_blank"
					>
						<div
							id="mc_embed_signup_scroll"
							className="flex justify-center items-center gap-2"
						>
							<div>
								<input
									label="Email Address"
									type="email"
									name="EMAIL"
									id="mce-EMAIL"
									placeholder="Enter your email"
									required
									defaultValue=""
									className="max-w-[200px] md:max-w-[450px] px-6 py-3 rounded-xl text-gray-800 bg-white"
								/>
							</div>
							<div hidden>
								<input type="hidden" name="tags" value="11238843" />
							</div>
							<div id="mce-responses" className="clear">
								<div
									className="response"
									id="mce-error-response"
									style={{ display: "none" }}
								/>
								<div id="mce-success-response" style={{ display: "none" }} />
							</div>

							<button
								type="submit"
								name="Subscribe"
								id="mc-embedded-subscribe"
								value="SUBMIT"
								className="max-w-1/8 text-white bg-primary px-8 py-3 rounded-xl text-gray-800"
							>
								Subscribe
							</button>
						</div>
					</form>
				</motion.div>
			</div>
			<script
				type="text/javascript"
				src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"
			></script>
			<script
				type="text/javascript"
				dangerouslySetInnerHTML={{
					__html: `(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='TRACKINGL';ftypes[3]='url';fnames[4]='TRACKINGC';ftypes[4]='text';fnames[5]='COURIER';ftypes[5]='text';}(jQuery));var $mcj = jQuery.noConflict(true);`,
				}}
			/>
		</div>
	);
}
